// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__7JUqP","legacyBtn":"MutateMid_legacyBtn__qtyBK"};